;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.salesTouchPage = (function () {
    function setupAppCacheListeners () {
      const appCache = window.applicationCache
      if (appCache && appCache.addEventListener) {
        appCache.addEventListener('checking', function (event) {
          console.log('AppCache checking for updates.')
        }, false)

        appCache.addEventListener('downloading', function (event) {
          console.log('AppCache started download.')
        }, false)

        // appCache.addEventListener('progress', function(event) {
        //  console.log(event.loaded + " of " + event.total + " downloaded.");
        // }, false);

        appCache.addEventListener('cached', function (event) {
          console.log('AppCache done.')
        }, false)

        appCache.addEventListener('error', function (event) {
          console.log('AppCache ERROR!', event)

          if (navigator.onLine === true) { // If the user is connected to the internet.
            console.log('Error - Please contact the website administrator if this problem consists.')
          } else {
            console.log('You aren\'t connected to the internet. Some things might not be available.')
          }
        }, false)
      }

      $('.offline-link.offline').on('click', function () { return false })

      // source: http://robertnyman.com/html5/offline/online-offline-events.html
      const networkStatus = document.getElementById('network-status')
      const goOnline = function () {
        // console.log('back online');
        $('.offline-link').removeClass('offline')
        if (networkStatus != null) {
          networkStatus.innerHTML = 'Online'
          networkStatus.className = 'online'
        }
      }
      const goOffline = function () {
        // console.log('gone offline');
        $('.offline-link').addClass('offline')
        if (networkStatus != null) {
          networkStatus.innerHTML = 'Offline'
          networkStatus.className = 'offline'
        }
      }

      isOnline() ? goOnline() : goOffline()

      if (window.addEventListener) {
        /*
         Works well in Firefox and Opera with the
         Work Offline option in the File menu.
         Pulling the ethernet cable doesn't seem to trigger it.
         Later Google Chrome and Safari seem to trigger it well
         */
        window.addEventListener('online', goOnline, false)
        window.addEventListener('offline', goOffline, false)
      } else {
        /*
         Works in IE with the Work Offline option in the
         File menu and pulling the ethernet cable
         */
        document.body.ononline = goOnline
        document.body.onoffline = goOffline
      }
    }

    function isOnline () {
      return window.navigator.onLine
    }

    function checkNetworkOverlay () {
      if (!isOnline()) { return false }

      const $el = $(this.element)
      // console.log('checkNetworkOverlay', $el);
      // const href = $el.attr('href')
      const offlineHref = $el.attr('data-network-offline')
      // console.log('checkNetworkOverlay', href, offlineHref);
      if (offlineHref) {
        if (isOnline()) {
          // console.log('can connect!');
          $el.attr('href', $el.attr('data-network-online'))
        } else {
          // console.log('can NOT connect 2!');
          $el.attr('href', offlineHref)
        }
      }
      return true
    }

    const initialize = function () {
      // basic bool variable to be changed via slideshowPauseToggle()
      let paused = null

      // checks if slideshow is toggled for events
      function slideshowPauseToggle () {
        if (paused) {
          $('.js-salesTouchCarousel').slick('slickPlay')
          paused = false
        } else {
          $('.js-salesTouchCarousel').slick('slickPause')
          paused = true
        }
      }

      // sets up the show/hide overlay module
      $('.js-overlayToggle').on('click', function (e) {
        console.log('toggling an overlay', $(this).attr('id'))
        e.preventDefault()
        // check if its the community overlay
        if ($(this).attr('id') === 'communityDetailsTouch') {
          $('#communityOverlay').fadeToggle('700', function () {
            $('.js-touchscreenslideSlick').resize() // Forces it to recalculate size
          })
          return
        }
        // check if its the form overlay
        slideshowPauseToggle()
        if ($(this).attr('id') === 'formDetailsTouch') {
          $('#formOverlay').fadeToggle('700', function () {
          })
        } else {
          $('.touchscreen-overlay').fadeOut('700', function () {
          })
        }
      })

      // sets slick carousel for main imagery
      $('.js-salesTouchCarousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 11000,
        cssEase: 'ease',
        dots: false,
        draggable: true,
        fade: true,
        accessibility: true,
        infinite: true,
        speed: 1500,
        swipe: true,
        pauseOnHover: false,
        touchMove: true
      })

      $('.js-touchscreenslideSlick').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        arrows: true,
        cssEase: 'ease',
        dots: true,
        draggable: true,
        infinite: true,
        swipe: true,
        slide: '.infoslide',
        pauseOnHover: false,
        touchMove: false,
        onInit: function (me) { // Turn the paging into icon buttons
          console.log('Here my dots: ', me.$dots)
          console.log(me.$dots.find('li'))

          me.$dots.find('li').each(function () {
            $(this).find('a').html('<i class=\'fa fa-circle-o\'></i><i class=\'fa fa-circle\'></i>')
          })
        }
      })

      var windowWidth = $(window).width()

      var modalWidth = windowWidth - 130
      var modalHeight = $(window).height() - 50

      if ((windowWidth > 1024) && (windowWidth < 1610)) {
        modalWidth = 1000
        modalHeight = 563
      } else if (windowWidth >= 1610) {
        modalWidth = 1603
        modalHeight = 902
      }

      $('.js-salesTouchscreen').on('click', function (i) {
        slideshowPauseToggle()
        $('#communityOverlay').fadeOut('300', function () {
        })
      })

      $('.js-salesTouchscreen.offline-link').each(function (i, el) {
        var $el = $(el)
        $el.attr('data-network-online', $el.attr('href'))

        $el.fancybox({
          type: 'iframe',
          href: $el.attr('href'),
          autoSize: false, // This is being used strictly for videos so enforce a viewing size
          height: modalHeight,
          scrolling: 'no',
          beforeLoad: checkNetworkOverlay
        })
      })

      $('.js-salesTouchscreen.link').each(function (i, el) {
        var $el = $(el)
        $el.fancybox({
          type: 'iframe',
          href: $el.attr('href'),
          autoSize: false, // This is being used strictly for videos so enforce a viewing size
          width: modalWidth,
          height: modalHeight,
          aspectRatio: true,
          scrolling: 'no'
        })
      })

      $('.js-salesTouchscreen.video').each(function (i, el) {
        var $el = $(el)
        $el.fancybox({
          type: 'iframe',
          href: $el.attr('href'),
          autoSize: false,
          width: modalWidth,
          height: modalHeight,
          scrolling: 'no'
        })
      })

      $('.js-salesTouchscreen.map').each(function (i, el) {
        var $el = $(el)
        $el.fancybox({
          type: 'iframe',
          href: $el.attr('href'),
          autoSize: false,
          width: modalWidth,
          height: modalHeight + 150,
          scrolling: 'no'
        })
      })

      function canConnectTo (url) { // eslint-disable-line no-unused-vars
        // url = 'http://dashboard.eahomes.com';
        console.log('canConnectTo', url)
        const xhr = new window.XMLHttpRequest()
        const randomNum = Math.round(Math.random() * 10000)

        xhr.open('HEAD', url + '?rand=' + randomNum, false)

        try {
          console.log('sending request ...')
          xhr.send()

          if (xhr.status >= 200 && xhr.status < 304) {
            console.log('online and good!')
            return true
          } else {
            console.log('not online?')
            return false
          }
        } catch (e) {
          console.log('error during check!')
          return false
        }
      }

      setupAppCacheListeners()
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.salesTouchPage.initialize()
  })
}(jQuery, window))
